import { withVersions } from "v2/hocs/withVersions";
import withStepper from "../hocs/withStepper";
import StepperV1 from "./Stepper/v1";
import StepperV2 from "./Stepper/v2";

const Stepper = withVersions({
  v1: withStepper(StepperV1),
  v2: withStepper(StepperV2),
});

export default Stepper;
